import type {
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
  RouteLocationNormalizedLoadedGeneric
} from 'vue-router'
import { useRouterUtils } from './useRouterUtils'
import { ROUTER_PATHS } from '@/constants/router/paths'
import { signout } from '@/features/miiaFw/utils/miiaFwCognito'
import { useLoadingView } from '@/features/miiaFw/composables/useLoadingView'
import { GlobalError } from '@/utils/globalError/globalError'
import { ERROR_CODES } from '@/constants/error/errorCode'

/*
 * 認証ガードを定義
 */
export const authGuard = async (
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedLoadedGeneric,
  next: NavigationGuardNext
) => {
  await authGuardCore(to, next)
}

/**
 * 共通の認証ガード
 * 認証状態を確認し、未認証ならログインへリダイレクト＋サインアウト＋エラー通知
 * @param to 遷移先ルート
 * @param next ルーターの`next`コールバック
 */
const authGuardCore = async (to: RouteLocationNormalizedGeneric, next: NavigationGuardNext) => {
  const { setLoadingView } = useLoadingView()
  const { getAuthorized } = useRouterUtils()

  setLoadingView(true)
  try {
    if (!to.meta.requiresAuth) {
      // 認証不要なら即許可
      return next()
    }
    if (await getAuthorized()) {
      // 認証済なら遷移許可
      return next()
    }
    // 以下認証が必要で未認証時
    signout()
    new GlobalError([ERROR_CODES.ROUTE_ACCESS_ERROR]).showErrorMessage()
    return next({ path: ROUTER_PATHS.login })
  } finally {
    setLoadingView(false)
  }
}
